import { render } from "./NotificationSender.vue?vue&type=template&id=4a556df4&scoped=true"
import script from "./NotificationSender.vue?vue&type=script&lang=js"
export * from "./NotificationSender.vue?vue&type=script&lang=js"

import "./NotificationSender.vue?vue&type=style&index=0&id=4a556df4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a556df4"]])

export default __exports__